/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon20Light = forwardRef('DataChartPieA2Icon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5A7.5 7.5 0 0 0 9.5 2Zm.5 7V3.02A6.5 6.5 0 0 1 15.98 9H10Z" }),
        React.createElement("path", { d: "M7.225 3.411a.5.5 0 0 0-.35-.937 7.5 7.5 0 1 0 9.639 9.683.5.5 0 0 0-.935-.354A6.5 6.5 0 1 1 7.225 3.41Z" })));
});
